import Plotly from 'plotly.js/dist/plotly'

export default defineNuxtPlugin((nuxtApp) => {
  window.plotly = Plotly
})
